import React, { Component } from "react";
import Header from "@components/Header";
import { MarkdownSection, RelevantArticles, MainFooter } from "@components";

import MDXContent from "./ValleyAutoFurnace.mdx";

class ValleyAutoFurnace extends Component {
        render() {
                return (
                        <div id="main">
                                <Header />
                                <MarkdownSection MDXContent={MDXContent} />
                                <RelevantArticles />
                                <MainFooter />
                        </div>
                );
        }
}

export default ValleyAutoFurnace;
